export default {
  // 账号注销认证
  unRegisterAuth(params) {
      return app.http.ajax({
          method: "post",
          url: "/cs-crm/user/unRegisterAuth",
          params: params,
      });
  },
  // 账号注销
  unRegister(params) {
    return app.http.ajax({
        method: "post",
        url: "/cs-crm/user/unRegister",
        params: params,
    });
  },
};